// w4.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W4 = () => {
  return <WW config={pageConfigs.w4} />;
};

export default W4;
